<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <app-patient-search-component id="patientSearch" #patientSearch (selected)="onPatientSelected($event)"></app-patient-search-component>
        <div *ngIf="patientSearched">
            <app-patient-view-component id="patientViewComponent" [patient]="patient" #patientViewComponent></app-patient-view-component>
        </div>
    </div>
    <!-- <div class="card-footer">
        <button color="primary" mat-flat-button matStepperNext type="submit">SIGUIENTE</button>
    </div> -->

    <div class="clearfix">
        <div class="pull-right margin-right-medium">
            <button class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>CANCELAR</button>
        </div>
        <div class="card-footer">
            <button color="primary" mat-flat-button matStepperNext type="submit">SIGUIENTE</button>
        </div>
    </div>
</div>
